const formatErrorDetail = (detail: unknown): string | null => {
  if (typeof detail === "string") {
    const value = detail.trim();
    return value || null;
  }

  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => formatErrorDetail(item))
      .filter((message): message is string => Boolean(message));

    return messages.length > 0 ? messages.join(", ") : null;
  }

  if (!detail || typeof detail !== "object") {
    return null;
  }

  const record = detail as Record<string, unknown>;

  if (typeof record.message === "string" && record.message.trim()) {
    return record.message.trim();
  }

  if (typeof record.msg === "string" && record.msg.trim()) {
    const location = Array.isArray(record.loc)
      ? record.loc
          .filter(
            (value): value is string | number =>
              typeof value === "string" || typeof value === "number",
          )
          .join(".")
      : "";

    return location ? `${location}: ${record.msg.trim()}` : record.msg.trim();
  }

  if ("detail" in record) {
    return formatErrorDetail(record.detail);
  }

  return null;
};

export const getApiErrorMessage = (error: any, fallback: string): string => {
  return (
    formatErrorDetail(error?.response?.data?.detail?.message) ||
    formatErrorDetail(error?.response?.data?.detail) ||
    formatErrorDetail(error?.response?.data?.message) ||
    formatErrorDetail(error?.message) ||
    fallback
  );
};
